import cx from "classnames";
import { ReactElement } from "react";

import { makeStyles } from "@material-ui/core";

import palette from "src/styles/palette";

const useStyles = makeStyles(() => ({
  calleeFieldSpan: {
    background: palette.midGray,
    borderRadius: "1rem",
    padding: "0 0.5rem",
    display: "inline-block",
    lineHeight: "1.5"
  },
  invalid: {
    background: palette.red,
    color: "#fff"
  }
}));

export const CalleeFieldSpan = ({
  children,
  isInvalid = false
}: {
  children: ReactElement;
  isInvalid?: boolean;
}): JSX.Element => {
  const classes = useStyles(makeStyles);
  return (
    <span
      className={cx(classes.calleeFieldSpan, { [classes.invalid]: isInvalid })}
    >
      {children}
    </span>
  );
};

export const InvalidCalleeFieldSpan = ({
  children
}: {
  children: ReactElement;
}): JSX.Element => {
  return <CalleeFieldSpan isInvalid>{children}</CalleeFieldSpan>;
};
